<template>
  <div>
    <mf-button color="marca-0-l40" :loading="isLoading" icon="download" label="Exportar PDF" @click="downloadPdf" />

    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :filename="filename"
      :pdf-quality="2"
      manual-pagination
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1123px"
      :paginate-elements-by-height="794"
      @hasDownloaded="hasDownloaded($event)"
    >
      <div slot="pdf-content">
        <MfPdfCover :title="title" :subtitle="subtitle" :name="$getLoggedUser().client" />
        <slot />
      </div>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
export default {
  name: 'ExportPdf',
  components: { VueHtml2pdf },
  props: {
    logoUrl: {
      type: String,
      default: '',
    },
    filename: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    booleanLoader: false,
  }),
  computed: {
    isLoading() {
      return this.booleanLoader || this.loading
    },
  },
  methods: {
    async downloadPdf() {
      try {
        this.booleanLoader = true
        await this.$refs.html2Pdf.generatePdf()
      } catch (error) {
        console.log(error)
        this.booleanLoader = false
      }
    },
    hasDownloaded() {
      this.booleanLoader = false
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  color: $branco !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  width: 145px;
}

::v-deep .pdf-item {
  padding: 0;
  margin: 0;
  height: 794px;
  width: 100%;
}
</style>
